import encryption from '@/utils/encryption'

/** Encrypted graph query for `graph_enc`, as admin-dashboard's `stringifyGraph` builds it. */
export const stringifyGraph = (graph: Record<string, any>): string => {
  const process = (obj: Record<string, any>): string =>
    Object.entries(obj)
      .map(([key, value]) => (typeof value === 'object' && value !== null ? `${key}{${process(value)}}` : key))
      .join(',')

  const secret = import.meta.env.VITE_GRAPHSQL_SECRET || '0'
  return encryption.encrypt(`{${process(graph)}}`, secret)
}
